import ListaItemModel from "./ListaItemModel";

export default class ListaModel {
  public listaId: string = "";
  public nome: string = "";
  public items: ListaItemModel[] = [];
}